
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-rental",
      function () {
        return require("private-next-pages/car-rental.js");
      }
    ]);
  